import { Grid } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { OPCheckBox } from '../../../OPcomponents/OPCheckBox'
import CVCard from './CVCard'
import { useCVSettings } from './CVSettingsContext'

export const ProjectHistoryPPTXCard: React.FC = () => {
  const { t } = useTranslation()
  const { state, handleSwitchChange } = useCVSettings()
  const { pptx_inc_projects, pptx_inc_keyprojects, pptx_inc_netumonly, pptx_inc_projectclientname } = state

  return (
    <CVCard
      title={t('CVTemplates.ProjectHistory')}
      description={t('CVTemplates.ProjectExperienceAndClientWork')}
      isEnabled={pptx_inc_projects}
      toggleName='pptx_inc_projects'
      onToggleChange={handleSwitchChange}
    >
      <Grid item>
        <OPCheckBox
          name='pptx_inc_keyprojects'
          label={t('CVTemplates.KeyProjectsOnly')}
          value={pptx_inc_keyprojects}
          onChangeState={handleSwitchChange}
        />
      </Grid>
      <Grid item>
        <OPCheckBox
          name='pptx_inc_netumonly'
          label={t('CVTemplates.NetumProjectsOnly')}
          value={pptx_inc_netumonly}
          onChangeState={handleSwitchChange}
        />
      </Grid>
      <Grid item>
        <OPCheckBox
          name='pptx_inc_projectclientname'
          label={t('CVTemplates.ShowClientName')}
          value={pptx_inc_projectclientname}
          onChangeState={handleSwitchChange}
        />
      </Grid>
    </CVCard>
  )
}
